import { HighlightedArticles } from '@/components/HighlightedArticles';
import { useAppState } from '@/hooks/useAppState';
import { LabradorComponent } from '@/types/component';
import { logger } from '@/utils/logger';
import { StandaloneHighlightedArticlesProps } from 'base/components/HighlightedArticles';
import { getHighlightedArticles } from 'lib/data/highlightedArticles';
import { getMostReadArticlesIds } from 'lib/data/mostRead';
import { fetchArticlesData } from 'lib/labrador/fetchArticlesData';
import { useState } from 'react';
import { useAsync } from 'react-use';

export const LabradorHighlightedArticles: LabradorComponent = ({ type, meta, data, descendants, ...props }) => {
  const [{ pageId = 0 }] = useAppState();

  const [articlesData, setArticlesData] = useState<
    | {
        articles?: StandaloneHighlightedArticlesProps['articles'];
        showBlip?: boolean;
        isLoading?: boolean;
      }
    | undefined
  >({ isLoading: data.isEnabled });

  useAsync(async () => {
    if (!data.isEnabled) return;

    try {
      const highlightedArticles = await getHighlightedArticles({ label: data.title, excludeIds: [pageId] });

      if (highlightedArticles?.length) {
        setArticlesData({ articles: highlightedArticles, showBlip: true, isLoading: false });
      } else {
        const mostReadArticleIds = await getMostReadArticlesIds({ excludeIds: [pageId], limit: 5 });

        const highlightedArticlesFallback = (await fetchArticlesData(mostReadArticleIds.map(String)))?.result?.map(
          (article: any) => {
            return {
              headline: article.title,
              label: 'Mest läst',
              link: { href: article.published_url },
            };
          },
        );

        setArticlesData({ articles: highlightedArticlesFallback, showBlip: false, isLoading: false });
      }
    } catch (err) {
      logger.error(err);
      setArticlesData({ isLoading: false });
    }
  }, [pageId]);

  if (!data.isEnabled) {
    return null;
  }

  return <HighlightedArticles {...articlesData} {...props} />;
};
